import { OrgTypes } from '@mode/shared/contract-common';
import * as angular from 'angular';
import { appendTrackingParamsToUrl } from '~/lib/append-tacking-params';

import { ConnectDatabaseElementId, COOKIE_DATASOURCE_HIDE } from '../../common/constants';

class DataSourceBannerController {
  static $inject = ['$window', 'CookieService'];

  private owner: OrgTypes.Organization;

  private minimize = false;
  private studioText = `Before you connect a database, you'll need to create a free Mode Studio workspace. This will let you query and share data privately with others. You can return to the Mode Community at any point.`;

  constructor(
    private $window,
    private CookieService
  ) {
    if (this.CookieService.getOrSetBooleanValue(COOKIE_DATASOURCE_HIDE)) {
      this.minimize = true;
    }
  }

  hide() {
    const options = {
      path: '/',
    };

    this.minimize = true;
    this.CookieService.getOrSetBooleanValue(COOKIE_DATASOURCE_HIDE, true, options);
  }

  goToNewOrganization() {
    const urlWithTrackingParams = appendTrackingParamsToUrl(
      this.owner.links.newOrganization,
      ConnectDatabaseElementId.COMMUNITY_DATA_SOURCE_BANNER_CTA
    );
    this.$window.location.href = urlWithTrackingParams;
  }
}

const DataSourceBannerComponent: angular.IComponentOptions = {
  bindings: {
    owner: '<',
    hasNoOrgs: '<',
  },
  template: `
<div class="datasource-banner-component" ng-if="!ctrl.minimize && ctrl.owner.user && ctrl.hasNoOrgs">
  <i class="icon-add-db-green banner-image"></i>
  <div>
    <p class="banner-text">Connect a database to start querying against your own data.</p>
  </div>
  <div class="banner-button">
    <a href="#" ng-click="ctrl.hide()" class="btn btn-lg btn-link banner-link">Not now</a>
    <a
      connect-db-instrumentation
      href="#"
      target="_self"
      connect-db-instrumentation-element-id="6"
      connect-db-instrumentation-org-id="{{ ctrl.owner.id }}"
      class="btn btn-lg btn-primary"
      confirm-modal="{{ ctrl.studioText }}"
      confirm-modal-title="Switch to Mode Studio"
      confirm-modal-button-confirm="Create Mode Studio workspace"
      confirm-modal-button-cancel="Back"
      confirm-modal-on-confirm="ctrl.goToNewOrganization()"
    >Connect Database</a>
  </div>
</div>
`,
  controller: DataSourceBannerController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('datasourceBanner', DataSourceBannerComponent);
